import store from '@/store'

/**
 * 对报表数据根据权限来过滤查询数据范围
 * @param {技能组数组数据} groupdata
 * @param {模块名称} _module
 * @param {权限组path} scopePath
 */
export function filterGroupData(defaultGroupData, zxzGroupData, value, userInfo) {
  if (value === 'ALL' || value.option === 'ALL') {
    return defaultGroupData
  } else if (value.option === 'jkckzj') { // 仅可查看自己
    const groups = []
    userInfo.skillGroups.forEach(group => groups.push({ id: group.id, name: group.name, skillUsers: [{ id: userInfo.id, name: userInfo.userName, skillGroupId: group.id, userGroupId: userInfo.userGroup.id }] }))

    return groups
  } else if (value.option === 'ckszzxz') { // 查看所在坐席组
    return zxzGroupData.matchedSkillGroups
  } else if (value.option === 'ckssjnz') { // 查看所属技能组
    const groups = []
    userInfo.skillGroups.forEach(group => groups.push({ id: group.id, name: group.name, skillUsers: [] }))

    defaultGroupData.forEach(d => {
      groups.some(group => {
        if (d.id === group.id) {
          group.skillUsers = d.skillUsers
          return true
        }
      })
    })

    return groups
  } else if (value.option === 'zdykz') { // 自定义跨组查看
    // 技能组数据筛选
    const jnzData = JSON.parse(JSON.stringify(value.detail.jnzData))
    if (jnzData.length > 0) {
      defaultGroupData.forEach(d => {
        jnzData.some(group => {
          if (d.id === group.id) {
            group.skillUsers = d.skillUsers
            return true
          }
        })
      })
    }
    // 坐席组数据筛选
    var groupJnzData = {}
    if (zxzGroupData !== {} && zxzGroupData.matchedSkillGroups) {
      if (jnzData.length > 0 && zxzGroupData.matchedSkillGroups.length > 0) {
        // 取技能组id分组数据
        jnzData.forEach(j => { groupJnzData[j.id] = j })
        // 将坐席组数据合并到技能组分组数据中
        zxzGroupData.matchedSkillGroups.forEach((j) => {
          if (groupJnzData[j.id]) {
            j.skillUsers.forEach(js => {
              var flag = false
              groupJnzData[j.id].skillUsers.some(gs => {
                if (gs.id === js.id) {
                  flag = true
                  return true
                }
              })
              if (!flag) {
                groupJnzData[j.id].skillUsers.push(js)
              }
            })
          } else {
            groupJnzData[j.id] = j
          }
        })
      } else if (zxzGroupData.matchedSkillGroups.length > 0) {
        zxzGroupData.matchedSkillGroups.forEach(j => { groupJnzData[j.id] = j })
      } else if (jnzData.length > 0) {
        jnzData.forEach(j => { groupJnzData[j.id] = j })
      }
    } else if (jnzData.length > 0) {
      jnzData.forEach(j => { groupJnzData[j.id] = j })
    }
    // 个人数据筛选
    var finalGroups = []
    const selfJnzData = []
    userInfo.skillGroups.forEach(group => selfJnzData.push({ id: group.id, name: group.name, skillUsers: [{ id: userInfo.id, name: userInfo.userName, skillGroupId: group.id, userGroupId: userInfo.userGroup.id }] }))
    if (Object.keys(groupJnzData).length > 0) {
      selfJnzData.forEach(s => {
        if (groupJnzData[s.id]) {
          s.skillUsers.forEach(ss => {
            var flag = false
            groupJnzData[s.id].skillUsers.some(gs => {
              if (gs.id === ss.id) {
                flag = true
                return true
              }
            })
            if (!flag) {
              groupJnzData[s.id].skillUsers.push(ss)
            }
          })
        } else {
          groupJnzData[s.id] = s
        }
      })
      finalGroups = Object.values(groupJnzData)
    } else {
      finalGroups = JSON.parse(JSON.stringify(selfJnzData))
    }
    return finalGroups
  }
  return []
}

/**
  * 获取type=2的模块数据查询权限权限
  * @param {模块名称} module
  * @param {权限组path} path
  */
export function hasScopeValue(module, path) {
  const moduleAuth = store.state.user.appAuthDetail[module]
  const temp = recuScopeValue(moduleAuth, path)
  if (temp && JSON.stringify(temp).indexOf('option') > -1 && (temp.option === null || temp.option === undefined)) {
    return JSON.parse(temp)
  }
  if (temp === undefined || temp.option === null || temp.option === undefined) {
    return 'ALL'
  }
  return temp
}

/**
 * 循环查找满足条件的数据
 * @param {*} tree
 * @param {*} path
 */
export function recuScopeValue(tree, path) {
  var stark = []
  stark = stark.concat(tree)
  while (stark.length) {
    var temp = stark.shift()
    if (temp && temp.children) {
      stark = temp.children.concat(stark)
    }
    if (temp && path === temp.path) {
      return temp.value
    }
  }
}

/**
 * 循环查找坐席组id相等的数据，同时返回子坐席组数据
 * @param {*} tree
 * @param {*} userGroupId
 */
export function recuUserGroupData(tree, userGroupId) {
  var stark = []
  stark = stark.concat(tree)
  while (stark.length) {
    var temp = stark.shift()
    if (temp && userGroupId === temp.id) {
      return temp
    }
    if (temp && temp.children) {
      stark = temp.children.concat(stark)
    }
  }
}
